"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheableResource = void 0;
const resource_model_1 = require("./resource.model");
/**
 * An abstract class to inherit to manage a resource model.
 * @deprecated
 */
class CacheableResource extends resource_model_1.Resource {
    constructor(x, options) {
        super(x, options);
        this.mAt = Date.now();
    }
    /**
     * Update `mAt` after a change in the object.
     */
    tick() {
        this.mAt = Date.now();
    }
    validate(options) {
        const e = super.validate(options);
        this.tick();
        return e;
    }
}
exports.CacheableResource = CacheableResource;
